import gql from "graphql-tag";

export const EXECUTE_ANONYMOUS = gql`
  mutation executeAnonymous {
    executeAnonymous
  }
`;
